import React, { createRef } from 'react';
import { imageWithPrefix } from '../../scripts/helpers';
import { placeholder } from '../../scripts/media';
export type ImageProps = {
  lazyLoading?: any;
  alt?: string;
  src: string;
  className?: string;
  id?: string;
  width?: string;
  height?: string;
  placeholder?: string;
};

class Image extends React.Component<ImageProps> {
  private placeholderRef: any;
  constructor(props: ImageProps) {
    super(props);
    if (props.lazyLoading) {
      this.placeholderRef = createRef();
    }
  }
  options = this.updateOptions();

  updateOptions() {
    const options: any = Object.assign({}, this.props);
    if (options.placeholder) {
      delete options.placeholder;
    }
    options.alt = options.alt || '';
    if (this.props.lazyLoading) {
      options.src = this.props.placeholder || placeholder;
      options['data-src'] = this.props.src;
      delete options.lazyLoading;
    } else {
      options.src = imageWithPrefix(this.props.src);
    }
    return options;
  }
  componentDidUpdate(prevProps: ImageProps): void {
    if (prevProps.src !== this.props.src) {
      this.options = this.updateOptions();
      if (this.props.lazyLoading) {
        this.observe();
      }
    }
  }
  observe() {
    const observer = new IntersectionObserver(
      (entries, obs) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.setAttribute('src', imageWithPrefix(this.props.src));
            obs.disconnect();
          }
        }
      },
      {
        rootMargin: '100px',
        threshold: 0,
      },
    );
    observer.observe(this.placeholderRef.current);
    return () => {
      observer.disconnect();
    };
  }
  componentDidMount() {
    if (this.props.lazyLoading) {
      this.observe();
    }
  }
  render() {
    return (
      <>
        {this.props.lazyLoading ? (
          <img
            {...this.options}
            ref={this.placeholderRef}
            loading="lazy"
          />
        ) : (
          <img
            {...this.options}
            loading="lazy"
          />
        )}
      </>
    );
  }
}

export default Image;
